<template>
    <div class="son-page">
        <!-- 编辑套餐弹窗 -->
        <edit-package
            v-show="editModal.show"
            :value="editModal.show"
            :modal-data="editModal"
            @input="(val) => (editModal.show = val)"
            @refresh="getList"
        ></edit-package>

        <div>
            <div class="top-change">
                <div class="top-search">
                    <Form inline :label-width="80">
                        <FormItem style="margin: 0" label="套餐名称">
                            <Input
                                placeholder="请输入套餐名称"
                                v-model="storePrams.keyword"
                                style="width: 180px; margin-right: 20px"
                            />
                        </FormItem>
                        <FormItem style="margin: 0" label="类型">
                            <Select
                                v-model="storePrams.combo_type"
                                style="width: 180px"
                            >
                                <Option value="0">全部类型</Option>
                                <Option value="1">固定搭配</Option>
                                <Option value="2">随心选</Option>
                            </Select>
                        </FormItem>
                        <FormItem style="margin: 0" label="状态">
                            <Select
                                v-model="storePrams.status"
                                style="width: 180px"
                            >
                                <Option value="0">全部状态</Option>
                                <Option value="1">上架</Option>
                                <Option value="2">下架</Option>
                            </Select>
                        </FormItem>
                        <FormItem style="margin: 0">
                            <div @click="searchBtn" class="btn-style">搜索</div>
                        </FormItem>
                    </Form>
                </div>
            </div>
            <div class="table-wrap">
                <div class="add_search_box" style="padding: 20px 0">
                    <div>
                        <Select v-model="modl" style="width: 180px">
                            <Option
                                v-for="item in batchOptions"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}</Option
                            >
                        </Select>
                        <Button
                            class="btn"
                            @click="implement"
                            style="margin-left: 20px"
                            >执行</Button
                        >
                    </div>
                    <div>
                        <Button @click="addPackageBtn('add')" class="btn"
                            >+ 新建套餐</Button
                        >
                    </div>
                </div>
                <Table
                    @on-selection-change="selectionChange"
                    ref="selection"
                    stripe
                    :columns="worlkColumns"
                    :data="data6"
                >
                    <template slot-scope="{ row }" slot="combo_img_domain">
                        <div class="cover-img">
                            <img
                                v-if="row.combo_img_domain"
                                :src="row.combo_img_domain"
                                alt="套餐封面"
                            />
                            <Icon v-else type="ios-image-outline" size="30" />
                        </div>
                    </template>
                    <template slot-scope="{ row }" slot="combo_type">
                        <Tag :color="row.combo_type == 1 ? 'purple' : 'blue'">{{
                            row.combo_type == 1 ? "固定搭配" : "随心选"
                        }}</Tag>
                    </template>
                    <template slot-scope="{ row }" slot="combo_price">
                        <span style="color: #ff761d; font-weight: bold"
                            >¥{{ row.combo_price }}</span
                        >
                    </template>
                    <template slot-scope="{ row }" slot="status">
                        <i-switch
                            @on-change="put(row)"
                            v-model="row.status"
                            size="large"
                            :true-value="1"
                            :false-value="2"
                        >
                            <span slot="open">上架</span>
                            <span slot="close">下架</span>
                        </i-switch>
                    </template>
                    <template slot-scope="{ row }" slot="operation">
                        <Button
                            @click="addPackageBtn(row.id)"
                            type="info"
                            ghost
                            size="small"
                            style="margin-right: 5px"
                            >编辑</Button
                        >
                        <Button
                            @click="delBtn(row.id)"
                            type="error"
                            ghost
                            size="small"
                            >删除</Button
                        >
                    </template>
                </Table>
                <br />
                <Page
                    :total="total"
                    :current="storePrams.page"
                    style="text-align: right"
                    show-elevator
                    show-total
                    @on-change="pageChange"
                    :page-size="storePrams.limit"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { comboList, comboStatus, comboDel, comboHandle } from "@/api/customer";
import EditPackage from "./editPackage.vue";

export default {
    components: { EditPackage },
    name: "packageList",
    data() {
        return {
            editModal: {
                show: false,
                id: null,
                type: 1, // 1:新增 2:编辑
            },
            modl: "0",
            total: 0,
            storePrams: {
                page: 1,
                limit: 10,
                keyword: "",
                combo_type: "0",
                status: "0",
            },
            data6: [],
            worlkColumns: [
                {
                    type: "selection",
                    width: 60,
                    align: "center",
                },
                {
                    title: "套餐ID",
                    key: "id",
                    align: "center",
                },
                {
                    title: "套餐名称",
                    key: "combo_name",
                    align: "center",
                },
                {
                    title: "封面",
                    slot: "combo_img_domain",
                    align: "center",
                },
                {
                    title: "类型",
                    slot: "combo_type",
                    align: "center",
                },
                {
                    title: "套餐价",
                    slot: "combo_price",
                    align: "center",
                },
                {
                    title: "状态",
                    slot: "status",
                    align: "center",
                },
                {
                    title: "操作",
                    key: "action",
                    width: 200,
                    fixed: "right",
                    align: "center",
                    slot: "operation",
                },
            ],
            batchOptions: [
                {
                    value: "1",
                    label: "全部上架",
                },
                {
                    value: "2",
                    label: "全部下架",
                },
                {
                    value: "3",
                    label: "全部删除",
                },
            ],
            ids: [],
        };
    },
    created() {
        this.getList();
    },
    methods: {
        getList() {
            // TODO: 调用API获取套餐列表
            comboList(this.storePrams).then((res) => {
                this.total = res.data.total;
                this.data6 = res.data.data;
            });
        },
        delBtn(id) {
            this.$Modal.confirm({
                title: "提示",
                content: `您正在使用删除功能`,
                onOk: () => {
                    // TODO: 调用删除API
                    comboDel({ id: id })
                        .then((res) => {
                            this.$Message.success(res.msg);
                            this.getList();
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        put(row) {
            // TODO: 调用上下架API
            this.$Modal.confirm({
                title: "提示",
                content: `您正在使用${row.status == 1 ? "上架" : "下架"}功能`,
                onOk: () => {
                    var data = {
                        id: row.id,
                        status: row.status,
                    };
                    comboStatus(data)
                        .then((res) => {
                            this.$Message.success(res.msg);
                            this.getList();
                        })
                        .catch((err) => {
                            this.$Message.error(err.msg);
                        });
                },
                onCancel: () => {},
            });
        },
        searchBtn() {
            this.storePrams.page = 1;
            this.getList();
        },
        selectionChange(row) {
            this.ids = [];
            row.forEach((item) => {
                this.ids.push(item.id);
            });
        },
        implement() {
            let data = {
                id: this.ids,
                type: this.modl,
            };
            if (data.id.length != 0 && data.type != "0") {
                comboHandle(data)
                    .then((res) => {
                        this.$Message.success(res.msg);
                        this.ids = [];
                        this.modl = "0";
                        this.getList();
                    })
                    .catch((err) => {
                        this.$Message.error(err.msg);
                    });
            } else {
                this.$Message.warning("请选择参数操作");
            }
        },
        addPackageBtn(e) {
            if (e === "add") {
                this.editModal.type = 1;
                this.editModal.id = null;
            } else {
                this.editModal.type = 2;
                this.editModal.id = e;
            }
            this.editModal.show = true;
        },
        pageChange(index) {
            this.storePrams.page = index;
            this.getList();
        },
    },
};
</script>

<style scoped>
.son-page {
    position: relative;
}
.top-change {
    width: 100%;
    background: white;
    border-radius: 12px;
    padding: 20px 30px;
    box-sizing: border-box;
}
.table-wrap {
    width: 100%;
    background: white;
    border-radius: 12px;
    padding: 20px 30px;
    box-sizing: border-box;
    margin-top: 30px;
}
.top-search {
    width: 100%;
    background: white;
    padding: 20px 0;
    border-radius: 10px;
    display: flex;
}
.add_search_box {
    display: flex;
    justify-content: space-between;
}
.btn-style {
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 16px;
    cursor: pointer;
    border-radius: 6px;
    background: #ff761d;
    width: 80px;
    height: 32px;
}
.cover-img {
    width: 60px;
    height: 60px;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    margin: 0 auto;
}
.cover-img img {
    width: 50px;
    height: 50px;
    object-fit: cover;
}
.btn {
    background: #ff761d;
    color: #fff;
    border-color: #ff761d;
}
</style>

<style>
.ivu-switch-checked {
    border-color: #ff761d;
    background-color: #ff761d;
}
.ivu-btn-primary {
    background: #ff761d;
    border-color: #ff761d;
}
.ivu-btn-primary:hover {
    background: #ff761d;
    border-color: #ff761d;
}
</style>
